var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-query-builder"},[_vm._t("default",function(){return [_c('QueryBuilderGroup',_vm._b({attrs:{"query":_vm.query},on:{"update:query":function($event){_vm.query=$event}}},'QueryBuilderGroup',_vm.vqbProps,false))]},null,_vm.vqbProps)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }